<style scoped>

  .table-segment {
    min-height: 250px;
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">
      <div class="twelve wide column">
        <div class="ui form m-t-5">
          <div class="ui radio checkbox financial-pending-certs-checkbox">
            <input type="radio" class="hidden" :value="$store.state.auth.user.id" v-model="userId">
            <label>Meus laudos</label>
          </div>        
          <div class="ui radio checkbox financial-pending-certs-checkbox" style="margin-left: 40px;">
            <input type="radio" class="hidden" :value="null" v-model="userId">
            <label>Todos os laudos</label>
          </div>
        </div>
      </div>
      <div class="four wide column">
        <div class="ui basic segment no-padding no-margin right aligned">
          <button class="ui icon button m-b-15" @click="$refs.filterModal.show()">
            <i class="filter icon" :class="{ red: !!$store.state.pages.filters.pendingCerts }"></i>
          </button>            
        </div>
      </div>
    </div>    

    <div v-if="!certs && loading"><i class="spinner circle loading blue icon m-t-10"></i> Carregando ...</div>

    <p v-if="!certs && !loading" class="grey text m-t-15">
      <i class="info circle icon"></i> Nenhum laudo encontrado
    </p>

    <div v-if="certs" class="ui basic segment no-padding no-margin animated fadeIn table-segment" :class="{ loading }">
      <table class="ui celled selectable tablet stackable table">
        <thead v-if="$isDesktop">
          <tr>
            <th>Laudo</th>
            <th>Financeiro</th>
            <th>Data</th>
            <th>Colaborador</th>
            <th>Clínica</th>
            <th>Serviço</th>
            <th>Animal</th>
            <th>Ficha</th>
            <th>Tutor</th>
          </tr>  
        </thead>
        <tbody>
          <tr v-for="(cert, index) in certs" :class="{ negative: cert.financialStatus == 'pending' }" @click="onRowClick(cert)">
            <td>
              <strong class="mobile-only">Laudo: </strong> 
              <i :class="cert.certStatusData.icon"></i>
              {{ cert.id }}
            </td>
            <td>
              <strong class="mobile-only">Financeiro: </strong> 
              <i :class="cert.financialStatusData.icon"></i>
              {{ cert.financialStatusData.description }}
            </td>
            <td>
              <strong class="mobile-only">Data: </strong> {{ $formatDate(cert.date) }}
            </td>
            <td>
              <strong class="mobile-only">Colaborador: </strong> {{ cert.userName }}
            </td>
            <td>
              <strong class="mobile-only">Clínica: </strong> {{ cert.customerName }}
            </td>
            <td>
              <strong class="mobile-only">Serviço: </strong> 
              {{ cert.serviceDescription }}
              <span class="ui small label m-l-10">
                <i :class="cert.serviceTypeData.icon"></i>
                {{ cert.serviceTypeDescription }}
              </span>
            </td>
            <td>
              <strong class="mobile-only">Animal: </strong> {{ cert.animalName }}
            </td>
            <td>
              <strong class="mobile-only">Ficha: </strong> {{ cert.registrationId }}
            </td>
            <td>
              <strong class="mobile-only">Tutor: </strong> {{ cert.ownerName }}
            </td>
          </tr>                
        </tbody>
      </table>      
    </div>      

    <filter-modal ref="filterModal" @onApply="onApplyFilter" @onRemove="onClearFilter" />  

  </div>

</template>

<script>

  import AppBrowser from "@/utils/browser"
  import BookmarkButton from "@/components/bookmark-button"
  import CertService from "@/services/cert-service"
  import SrvService from "@/services/srv-service"
  import onlySimavet from "@/mixins/only-simavet"
  import FilterModal from "./filter"

  export default {
    
    name: "FinancialPendingCertsPage",

    mixins: [onlySimavet],

    data() {
      return {
        title: "Laudos com Financeiro Pendente",
        loading: true,
        userId: this.$store.state.auth.user.id,
        certs: null,
        service: new CertService(),
        filter: null,
      }
    },

    components: {
      BookmarkButton,
      FilterModal,
    },  

    created() {

      if (this.$store.state.pages.filters.pendingCerts)
        this.filter = this.$cloneObject(this.$store.state.pages.filters.pendingCerts)

      this.loadCerts()
    },

    mounted() {
      $(".financial-pending-certs-checkbox").checkbox()
    },

    watch: {

      "userId" () {
        this.loadCerts()
      }
    },

    methods: {

      async loadCerts() {

        this.loading = true
        this.certs = null

        try {

          let certs = await this.service.findPendingCerts(this.userId, this.filter)

          certs.forEach((cert) => {
            cert.certStatusData = CertService.STATUS[cert.certStatus]
            cert.financialStatusData = CertService.FINANCIAL_STATUS[cert.financialStatus]
            cert.serviceTypeData = SrvService.TYPE_ICONS[cert.serviceTypeIcon]
          })

          if (certs.length > 0)
            this.certs = certs.slice()
          
        } catch (error) {

          this.$errorHandler(error)
          
        } finally {

          this.loading = false
        }
      },

      onRowClick(cert) {
        AppBrowser.openNewTab(`/procs/certs/${cert.id}/show`)
      },

      onApplyFilter(filter) {
        this.filter = filter
        this.loadCerts()
      },

      onClearFilter() {
        this.filter = null
        this.loadCerts()
      },
    },
  }

</script>